import styled from "styled-components";

export const ImgBanner = styled.img`
    background-repeat: no-repeat;
    background-size: cover;
    height: 32vw;
    max-height: 410px;
`;